import React, {memo} from 'react';
import Button from "../Buttons/Button";
import {avatarSize, ButtonSize} from "../../Data/Enums/Generic";
import {ColourMod} from "../../Data/Enums/LayoutEnums";
import MenuToggle from "../Actions/MenuToggle";
import Avatar from "../Avatars/Avatar";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSearch} from "@fortawesome/pro-solid-svg-icons";
import StackHorizontal from "../Wrappers/StackHorizontal";
import {FlexAlign} from "../../Data/Enums/LayoutEnums";

interface iHeaderOptions {
    isBranded?: boolean;
    showLogo?: boolean;
    showMenuModifier?: boolean;
    showTopUp?: boolean;
}

const LayoutHeader: React.FC<iHeaderOptions> = memo((props) => {
    const HeaderActions = () => {
        return (
            <div className={'generic-header-row ml-a'}>
                <div className={'input-overlay overlay-left'}>
                    <div className={'overlay-content'}>
                        <FontAwesomeIcon icon={faSearch} fixedWidth={true} />
                    </div>
                    <input type={'text'} placeholder={'Search...'} className={'m-0'}/>
                </div>

                {props.showTopUp && (
                    <Button title={'Top-up'}
                            raised={true}
                            size={ButtonSize.Small}
                            colour={ColourMod.Text} />
                )}

                <Button title={'User'} icon={<Avatar size={avatarSize.Small} />} iconOnly={true} squared={true} showArrow={true}/>
            </div>
        )
    }

    return (
        <div className={`generic-header ${props.isBranded ? 'branded' : ''}`}>
            <StackHorizontal align={FlexAlign.Center}>
                {props.showMenuModifier && (
                    <div className={'hide-uw'} style={{ marginInlineStart: props.showLogo ? '-0.3em' : '0', marginInlineEnd: props.showLogo ? 'var(--md-unit' : '0'}}>
                        <MenuToggle customColour={props.isBranded ? ColourMod.Success : null} />
                    </div>
                )}

                {props.showLogo && (
                    <div className={'header-logo-container'}>
                        <span className='logo-emblem' />
                    </div>
                )}

                <HeaderActions />

            </StackHorizontal>
        </div>
    );
});

export default LayoutHeader;
